module.exports = __webpack_public_path__ + "img/P150T_weapon_99.9584087b.png";